<app-page-header title="Dashboard"></app-page-header>

<div class="row">
  <div class="col-12 col-md-4 col-lg-3">

    <div class="card mb-4">
      <div class="card-header" [ngClass]="{'bg-danger':checkPastDue(invoices_summary?.current_invoice)}">
        Current Invoice <fa-icon [icon]="faSpinner" [spin]="true" class="float-end" *ngIf="invoicesLoading"></fa-icon>
        <span *ngIf="checkPastDue(invoices_summary?.current_invoice)"> - PAST DUE</span>
      </div>
      <div class="card-body">

        <div *ngIf="shouldShowModule('invoices') && invoicesLoading" class="skeleton-content">
          <div class="skeleton-line mb-2"></div>
          <div class="skeleton-line mb-2"></div>
          <div class="skeleton-line mb-2"></div>
          <div class="skeleton-line mb-2"></div>
          <div class="skeleton-line mb-2"></div>
          <div class="skeleton-line"></div>
        </div>

        <!-- No Data State -->
        <div *ngIf="!shouldShowModule('invoices') && !invoicesLoading && !hasInvoices()"
          class="text-center py-3 text-muted">
          <p class="mb-0 mt-2"><strong>All caught up!</strong></p>
              <small>No Invoice information at this time</small>
        </div>

        <div
          *ngIf="shouldShowModule('invoices') && hasInvoices() && invoices_summary?.current_invoice && !invoicesLoading">
          <dl class="row">
            <dt class="col-sm-5">Invoice Number</dt>
            <dd class="col-sm-7">
              <a class="button-link" (click)="createPdf()">
                #{{ invoices_summary.current_invoice.invoice_number }}
              </a>
            </dd>
            <dt class="col-sm-5">Date Issued</dt>
            <dd class="col-sm-7">
              {{ invoices_summary.current_invoice.date_sent | amDateFormat:'M/D/YYYY' }}
            </dd>
            <dt class="col-sm-5">Billing Period</dt>
            <dd class="col-sm-7">
              {{ invoices_summary.current_invoice.billing_period_date | amDateFormat:'MMMM YYYY' }}
            </dd>
            <dt class="col-sm-5">Due Date</dt>
            <dd class="col-sm-7">
              {{ invoices_summary.current_invoice?.date_due | amDateFormat:'M/D/YYYY' }}
            </dd>
            <dt class="col-sm-5">Invoice Amount</dt>
            <dd class="col-sm-7">{{ invoices_summary.current_invoice.item_amount | sbCurrency }}</dd>
            <dt class="col-sm-5">Invoice Balance</dt>
            <dd class="col-sm-7">
              {{ invoices_summary.current_invoice.balance | sbCurrency }}
              <span *ngIf="invoices_summary.current_invoice.settled" class="badge bg-success ms-2">Settled</span>
              <span *ngIf="!invoices_summary.current_invoice.settled" class="badge bg-danger ms-2">Unsettled</span>
            </dd>
          </dl>
        </div>
      </div>
    </div>

    <!-- Outstanding Invoices -->
    <div *ngFor="let outstanding_invoice of invoices_summary?.outstanding_invoices" class="card mb-4"
      [class.border-danger]="checkPastDue(outstanding_invoice)">
      <div class="card-header" [class.bg-danger]="checkPastDue(outstanding_invoice)"
        [class.text-white]="checkPastDue(outstanding_invoice)">
        {{ outstanding_invoice.billing_period_date | amDateFormat:'MMMM' }} Invoice
        <span *ngIf="checkPastDue(outstanding_invoice)"> - PAST DUE</span>
      </div>
      <div class="card-body">
        <dl class="row">
          <dt class="col-sm-5">Invoice Number</dt>
          <dd class="col-sm-7">#{{ outstanding_invoice.invoice_number }}</dd>
          <dt class="col-sm-5">Date Issued</dt>
          <dd class="col-sm-7">
            {{ outstanding_invoice.date_sent | amDateFormat:'M/D/YYYY' }}
          </dd>
          <dt class="col-sm-5">Billing Period</dt>
          <dd class="col-sm-7">
            {{ outstanding_invoice.billing_period_date | amDateFormat:'MMMM YYYY' }}
          </dd>
          <dt class="col-sm-5">Due Date</dt>
          <dd class="col-sm-7">
            {{ outstanding_invoice.date_due | amDateFormat:'M/D/YYYY' }}
          </dd>
          <dt class="col-sm-5">Invoice Amount</dt>
          <dd class="col-sm-7">{{ outstanding_invoice.item_amount | sbCurrency }}</dd>
          <dt class="col-sm-5">Invoice Balance</dt>
          <dd class="col-sm-7">
            {{ outstanding_invoice.balance | sbCurrency }}
            <span *ngIf="outstanding_invoice.settled" class="badge bg-success ms-2">Settled</span>
            <span *ngIf="!outstanding_invoice.settled" class="badge bg-danger ms-2">Unsettled</span>
          </dd>
        </dl>
      </div>
    </div>

    <!-- Property Team Section -->
    <div class="card mb-4">
      <div class="card-header">
        Need Help?
        <fa-icon [icon]="faSpinner" [spin]="true" class="float-end" *ngIf="propertyTeamLoading"></fa-icon>
      </div>
      <div class="card-body">

        <!-- Loading Skeleton -->
        <div *ngIf="shouldShowModule('property-team') && propertyTeamLoading" class="skeleton-content">
          <div class="d-flex align-items-center mb-3">
            <div class="skeleton-avatar me-3"></div>
            <div class="flex-grow-1 property-team-skeleton">
              <div class="skeleton-line mb-1"></div>
              <div class="skeleton-line mb-1"></div>
              <div class="skeleton-line"></div>
            </div>
          </div>
        </div>

        <!-- No Data State -->
        <div *ngIf="!shouldShowModule('property-team') && !propertyTeamLoading && !hasPropertyTeam()"
              class="text-center py-4 text-muted">
              <p class="mb-0 mt-2"><strong>All caught up!</strong></p>
              <small>No Property Team information at this time</small>
            </div>

        <!-- Data Loaded State -->
        <div *ngIf="shouldShowModule('property-team') && hasPropertyTeam() && !propertyTeamLoading">
          <div *ngFor="let client_portal_card of property_team; first as isFirst" class="text-center">
            <p class="mb-3">Your personal {{ client_portal_card.position?.name }} is standing by.</p>

            <div *ngIf="client_portal_card.user?.image_file" class="profile-image-wrapper">
              <p>
                <img [src]="client_portal_card.user.image_file.url" class="img-fluid rounded-circle"
                  [alt]="client_portal_card.user.image_file.file_name" />
              </p>
            </div>

            <h6 class="card-subtitle">{{ client_portal_card.user.name }}</h6>
            <p class="card-text">
              <span>
                <a *ngIf="client_portal_card.user?.email" href="mailto:{{ client_portal_card.user?.email }}">{{
                  client_portal_card.user.email }}</a>
              </span><br />
              <span *ngIf="client_portal_card.user?.phone"> {{ client_portal_card.user.phone | phone }}</span>
              <span *ngIf="client_portal_card.user?.phone_extension">
                Ext.
                {{ client_portal_card.user.phone_extension }}
              </span>
            </p>
            <p>
              <button *ngIf="isBookingUrlAvailable(client_portal_card.user?.booking_url)" kendoButton
                (click)="sendUserModel(client_portal_card.user)" [svgIcon]="calendarIcon" [primary]="true">
                Schedule Meeting
              </button>
              <button
                *ngIf="!isBookingUrlAvailable(client_portal_card.user?.booking_url) && client_portal_card.user?.email"
                kendoButton type="button" [primary]="true">
                <fa-icon [icon]="faEnvelope" [fixedWidth]="true"></fa-icon>
                <a href="mailto:{{ client_portal_card.user?.email }}" class="email-link">Email
                  {{client_portal_card.position?.name}}</a>
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div class="col-12 col-md-8 col-lg-9">
    <div class="row card-row">

      <!-- Enrollment Status -->
      <div #cardEnrollmentStatus class="col-12 col-lg-6 mb-4">
        <div class="card h-100">
          <div class="card-header">
            Enrollment Status
            <fa-icon [icon]="faSpinner" [spin]="true" class="float-end" *ngIf="residentProgressLoading"></fa-icon>
          </div>

          <div class="card-body">

            <!-- Loading Skeleton -->
            <div *ngIf="shouldShowModule('resident-progress') && residentProgressLoading" class="skeleton-content">
              <div class="skeleton-progress mb-3"></div>
              <div class="skeleton-line enrollment-skeleton"></div>
            </div>

            <!-- No Data State -->
            <div *ngIf="!shouldShowModule('resident-progress') && !residentProgressLoading && !hasResidentProgress()"
              class="text-center py-4 text-muted">
              <p class="mb-0 mt-2"><strong>All caught up!</strong></p>
              <small>No Enrollment Status data at this time</small>
            </div>

            <div *ngIf="shouldShowModule('resident-progress') && hasResidentProgress() && !residentProgressLoading">
              <div class="text-center mb-3">
                <h4 class="text-success"><strong>{{ resident_progress.percent_complete }}%</strong></h4>
                <p class="mb-0">of residents are enrolled at <strong>{{ session?.current_property?.name }}</strong></p>
              </div>

              <div class="progress mb-3 dashboard-progress">
                <div class="progress-bar bg-success" [style.width.%]="resident_progress.percent_complete"
                  [attr.aria-valuenow]="resident_progress.percent_complete">
                </div>
              </div>

              <div class="d-flex justify-content-between text-muted small">
                <span>{{ resident_progress.good_standing_count }} enrolled</span>
                <span>{{ resident_progress.resident_count }} total</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Billing Status -->
      <div #cardBillingStatus class="col-12 col-lg-6 mb-4" *ngIf="session.current_property.market?.type != 'SingleFamily'">
        <div class="card h-100">
          <div class="card-header">
            Billing Status
            <fa-icon [icon]="faSpinner" [spin]="true" class="float-end" *ngIf="billingProgressLoading"></fa-icon>
          </div>
          <div class="card-body">

            <!-- Loading Skeleton -->
            <div *ngIf="shouldShowModule('billing-progress') && billingProgressLoading" class="skeleton-content ">
              <div class="skeleton-progress mb-3"></div>
              <div class="skeleton-line billing-skeleton"></div>
            </div>

            <!-- Error State -->
            <div *ngIf="!billingProgressLoading && !hasBillingProgressData && billingProgressError"
              class="text-center py-4 text-muted alert alert-warning">
              {{billingProgressError}}
            </div>

            <!-- No Data State -->
            <div *ngIf="!shouldShowModule('billing-progress') && !billingProgressLoading && !billingProgressError && !hasBillingProgress()"
              class="text-center py-4 text-muted">
              <p class="mb-0 mt-2"><strong>All caught up!</strong></p>
              <small>No Billing Status data at this time</small>
            </div>

            <!-- Data Loaded State -->
            <div *ngIf="shouldShowModule('billing-progress') && hasBillingProgress() && !billingProgressLoading">
              <div class="text-center mb-3">
                <h4 class="text-primary"><strong>{{ billing_progress.percent_received }}%</strong></h4>
                <p class="mb-0">of bills have been received for <strong>{{ billing_progress.billing_period_date |
                    amDateFormat:'MMMM YYYY' }}</strong></p>
              </div>

              <div class="progress mb-3 dashboard-progress">
                <div class="progress-bar bg-primary" [style.width.%]="billing_progress.percent_received"
                  [attr.aria-valuenow]="billing_progress.percent_received">
                </div>
              </div>

              <div class="d-flex justify-content-between text-muted small">
                <span>{{ billing_progress.received_accounts }} received</span>
                <span>{{ billing_progress.total_accounts }} total</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Pre-Bill Summary -->
      <div #cardPreBill class="col-12 col-lg-6 mb-4">
        <div class="card h-100">
          <div class="card-header">
            Pre Bill
            <fa-icon [icon]="faSpinner" [spin]="true" class="float-end" *ngIf="preBillLoading"></fa-icon>
          </div>
          <div class="card-body">

            <!-- Loading Skeleton -->
            <div *ngIf="shouldShowModule('pre-bill') && preBillLoading" class="skeleton-content">
              <div class="skeleton-line mb-2"></div>
              <div class="skeleton-line mb-2 pre-bill-skeleton"></div>
              <div class="skeleton-badge"></div>
            </div>

            <!-- No Data State -->
            <div *ngIf="!shouldShowModule('pre-bill') && !hasPreBill() "
                 class="text-center py-4 text-muted">
              <p class="mb-0 mt-2"><strong>All caught up!</strong></p>
              <small>No Pre Bills at this time</small>
            </div>

            <!-- Data Loaded State -->
            <div
              *ngIf="shouldShowModule('pre-bill') && hasPreBill() && pre_bill_summary?.current_pre_bill && !preBillLoading">
              <div class="row">
                <div class="col-lg-9">
                  <!-- Outstanding Pre-bill -->
                  <div *ngIf="!pre_bill_summary.current_pre_bill.completed_date">
                    <p>
                      You have an outstanding pre-bill to complete for
                      {{ pre_bill_summary.current_pre_bill.billing_period_date | amDateFormat:'MMMM YYYY' }}.
                    </p>
                    <p>
                      <button kendoButton [svgIcon]="searchIcon" [routerLink]="['/pre-bill', pre_bill_summary.current_pre_bill.id]">
                        Review Now
                      </button>
                    </p>
                  </div>

                  <!-- Completed Pre-bill -->
                  <div *ngIf="pre_bill_summary.current_pre_bill.completed_date">
                    <p>
                      Pre-bill for
                      {{ pre_bill_summary.current_pre_bill.billing_period_date | amDateFormat:'MMMM YYYY' }}
                      was completed by {{ user_title }} on
                      {{ pre_bill_summary.current_pre_bill.completed_date | amDateFormat:'M/D/YYYY' }}.
                    </p>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div *ngIf="pre_bill_summary.pre_bill_milestone" class="text-center">
                    <span class="badge rounded-pill pre-bill-status-badge" [class]="pre_bill_summary.pre_bill_milestone.sla_status || 'bg-success'"
                      [title]="pre_bill_summary.pre_bill_milestone.pre_bill_sla_tooltip">
                      <fa-icon [icon]="faBell" *ngIf="pre_bill_summary.pre_bill_milestone.sla_status === 'bg-secondary'"
                        class="me-1"></fa-icon>
                      <fa-icon [icon]="faClock"
                        *ngIf="pre_bill_summary.pre_bill_milestone.sla_status !== 'bg-secondary'"
                        class="me-1"></fa-icon>
                      {{ pre_bill_summary.pre_bill_milestone.sla_message }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Outstanding Tasks -->
      <div #cardOutstandingTasks class="col-12 col-lg-6 mb-4">
        <div class="card workflow-card h-100">
          <div class="card-header">
            Outstanding Tasks
            <fa-icon [icon]="faSpinner" [spin]="true" class="float-end" *ngIf="workflowsLoading"></fa-icon>
          </div>
          <div class="card-body">

            <!-- Loading Skeleton -->
            <div *ngIf="shouldShowModule('workflows') && workflowsLoading" class="skeleton-content">
              <div class="skeleton-line mb-3"></div>
              <div class="skeleton-button"></div>
            </div>

            <!-- No Data State -->
            <div *ngIf="shouldShowNoWorkflows()"
                 class="text-center py-4 text-muted">
              <p class="mb-0 mt-2"><strong>All caught up!</strong></p>
              <small>No outstanding tasks at this time</small>
            </div>

            <!-- Data Loaded State -->
            <div *ngIf="shouldShowWorkflowsData()">
              <div class="mb-3">
                <p>You have <strong>{{ getWorkflowsCount() }}</strong> outstanding task<span *ngIf="isWorkflowsPlural()">s</span> to complete.</p>
                <p>
                  <button kendoButton icon="play" [routerLink]="['/workflows','start']">
                    {{ getWorkflowButtonText() }}
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Final Billing Approval -->
      <div #cardFinalBillingApproval class="col-12 col-lg-6 mb-4" *ngIf="session.current_property.final_billing_approval">
        <div class="card workflow-card h-100">
          <div class="card-header">
            Final Billing Approval
            <fa-icon [icon]="faSpinner" [spin]="true" class="float-end" *ngIf="workflowsLoading"></fa-icon>
          </div>
          <div class="card-body">

            <!-- Loading Skeleton -->
            <div *ngIf="shouldShowModule('workflows') && workflowsLoading" class="skeleton-content">
              <div class="skeleton-line mb-3"></div>
              <div class="skeleton-button"></div>
            </div>

            <!-- No Data State -->
            <div *ngIf="shouldShowNoEfbs()"
                 class="text-center py-4 text-muted">
              <p class="mb-0 mt-2"><strong>All caught up!</strong></p>
              <small>No Final Billing Approvals at this time</small>
            </div>

            <!-- Data Loaded State -->
            <div *ngIf="shouldShowEfbsData()">
              <p>You have <strong>{{ getPendingEfbCount() }}</strong> outstanding EFB<span *ngIf="isEfbsPlural()">s</span> to approve.</p>
              <p>
                <button kendoButton [svgIcon]="checkIcon" [routerLink]="['/on-demand-efbs']">
                  Review
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Customer Support -->
      <div #cardCustomerSupport class="col-12 col-lg-12 mb-4">
        <div class="card h-100">
          <div class="card-header">
            Customer Support
            <fa-icon [icon]="faSpinner" [spin]="true" class="float-end" *ngIf="customerServiceLoading"></fa-icon>
          </div>
          <div class="card-body">
            <!-- Loading Skeleton -->
            <div *ngIf="shouldShowModule('customer-service') && customerServiceLoading"
              class="skeleton-content d-flex align-items-center justify-content-center customer-service-skeleton">
              <div class="skeleton-chart"></div>
            </div>

            <!-- No Data State -->
            <div *ngIf="shouldShowModule('customer-service') && !customerServiceLoading && !hasCustomerService()"
              class="text-center py-5 text-muted">
              Customer Support data not available.
            </div>

            <div *ngIf="!shouldShowModule('customer-service') && !hasCustomerService()" class="text-center py-4 text-muted">
              <p class="mb-0 mt-2"><strong>All caught up!</strong></p>
              <small>No Customer Support requests at this time</small>
            </div>

            <!-- Data Loaded State -->
            <div
              *ngIf="shouldShowModule('customer-service') && hasCustomerService() && customer_service?.day_summaries?.length > 0 && !customerServiceLoading">
              <div id="customerservice-chart" class="dashboard-chart"></div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>